<template>
  <div>
    <div class="fixed-top"  style="z-index: 9; background-color: #ffffff">
      <div class="p-3 text-center" style="position: relative">
        <a href="javascript:" class="pl-1" @click="$router.go(-1)" style="position: absolute; left: 12px; top: 24px">
          <i class="fa fa-chevron-left text-danger"></i>
        </a>
        <h6 class="font-weight-bold mb-0">LeCard Delivery</h6>
        <small class="text-muted">Um Delivery sob medida para a sua empresa!</small>
      </div>
    </div>
    <div style="padding-top: 70px">
      <div class="img-background">
        <div class="conteudo">
          <div class="container py-5 text-white">
            <div class="text-center mb-5">
              <img :src="base_cdn + '/static/imgs/logo-lecard.png'" alt="Logo Lecard">
            </div>
            <h4 class="font-weight-bold mb-4">
              Tenha um delivery para o seu negócio e
              <span class="text-danger h5">conquiste mais clientes</span>
            </h4>
            <div class="mb-5">
              <a class="btn btn-danger" href="https://parceiros.lecard.delivery" target="_blank">ACESSE NOSSO SITE</a>
            </div>
            <h5 class="mb-5 text-center">Tudo que seu delivery precisa</h5>
            <div style="max-width: 500px; margin: auto">
              <div class="card bg-white p-4 text-dark">
                <h5 class="font-weight-bold text-center mb-4">VAMOS CONVERSAR ?</h5>
                <p>Temos uma proposta especial para o seu negócio!</p>
                <div>
                  <div>
                    <i class="fa fa-phone-square"></i> - (16) 98848-3315<br>
                    <i class="fa fa-phone-square"></i> - (35) 99816-0507<br>
                    <i class="fa fa-phone-square"></i> - (35) 99752-8006<br>
                    <i class="fa fa-phone-square"></i> - (16) 99362-6508<br>
                    <i class="fa fa-envelope"></i> - contato@storkdigital.com.br
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rodape p-5 text-center">
        <p>
          <i class="fa fa-copyright"></i> <span class="font-weight-bold">LeCard Delivery</span><br>
          Todos os direitos reservados <br>
          <span class="small">
            LeCard Delivery é uma marca <a href="https://storkdigital.com.br" class="text-danger font-weight-bold" target="_blank"><i class="fa fa-copyright"></i> Stork Digital</a>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from '../components/Loading'
  import BottomBar from '../components/BottomBar';
  import AdsLeCard from "../components/AdsLeCard";

  export default {
    name: 'LeCard',
    components: {AdsLeCard, Loading, BottomBar},
    data() {
      return {
      }
    },
    created() {
      window.scrollTo(0,0);
    }
  }
</script>
<style scoped>
  .img-background {
    background-image: url("https://lecard-cdn.nyc3.digitaloceanspaces.com/lecard-corporativo/static/imgs/bkg-lecard.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 800px;
    position: relative;
  }
  .conteudo {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
  }
  .conteudo img {
    width: 100px;
  }
</style>
